<template>
  <!-- Modal Overlay -->
  <div v-if="showModal" class="modal-overlay">
    <div class="modal-content">
      <span class="close-button" @click="closeModal">&times;</span>
      <h2>選擇卡片折抵</h2>
      <div v-if="offer_cards.length === 0" class="no-offer-cards">
        No offer cards available at the moment.
      </div>
      <div class="offer-cards-container">
        <div v-for="offerCard in offer_cards" :key="offerCard.id" class="offer-card">
          <div class="offer-card-image">
            <img :src="getOfferCardImageURL(offerCard.id)" :alt="`${offerCard.name} Image`" />
          </div>
          <div class="offer-card-details">
            <h3 class="offer-card-name">{{ offerCard.bank + ' | ' + offerCard.name }}</h3>
            <!-- <p class="offer-card-offer">{{ offerCard.offer }}</p> -->
          </div>

          <button class="apply-button" @click="selectCardAndGo(offerCard)">輸入卡號</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getFullImageURL } from '@/util/util';

export default {
  computed: {
    ...mapGetters(['user', 'registered_cards', 'offer_cards']),
  },
  data() {
    return {
      showModal: true,
      cardType: ''
    };
  },
  methods: {
    getFullImageURL,
    proceed() {
      this.$emit('updateState', { key: 'cardType', value: this.cardType });
      this.$emit('nextStep');
    },
    selectCardAndGo(offerCard) {
      this.$emit('updateState', { key: 'selectedOfferCard', value: offerCard });
      this.$emit('enter-card-number');
    },
    getOfferCardImageURL(offerCardId) {
      const cardImageDict = {};
      this.offer_cards.forEach(card => {
        cardImageDict[card.id] = card.card_image;
      });
      const card_image_path = cardImageDict[offerCardId];
      return card_image_path ? getFullImageURL(card_image_path) : getFullImageURL('/images/placeholder.png');
    },
    closeModal() {
      // this.showModal = false;
      this.$emit('cancel-card-select');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  /* align-items: center; */
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 10px;
  margin-top: 20vh;
  width: 640px;
  height: 720px;
  position: relative;
  text-align: center;
}

h2 {
  font-size: 24px;
  line-height: 33.6px;
  color: var(--green03);
  margin-top: 24px;
  margin-bottom: 30px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
  color: black;
}

.offer-cards-container {
  padding: 0px 30px;
  max-height: 619px;
  overflow-y: auto;
}

.offer-card {
  height: 123px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px;
  margin-bottom: 20px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 3px 3px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.offer-card-image {
  width: 120px;
  height: 75px;
  margin-right: 15px;

}

.offer-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;

  border-radius: 12px;

}

.offer-card-details {
  flex: 1;
  text-align: left;
}

.offer-card-name {
  margin: 5px 0;
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  /* white-space: nowrap; */
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--gray15);

  /*wrap on ' | ' */
  /* white-space: nowrap; */
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */

}

.apply-button {
  width: 112px;
  height: 48px;
  padding: 12px 24px;
  border-radius: 99px;
  border: none;
  color: white;
  background-color: var(--green03);
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}

.apply-button:hover {
  background-color: var(--green02);
}

/* Custom scrollbar styling */
.offer-cards-container::-webkit-scrollbar {
  width: 8px;
}

.offer-cards-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.offer-cards-container::-webkit-scrollbar-thumb {
  background-color: var(--gray11);
  border-radius: 10px;
  border: 1px solid #f1f1f1;
}

.offer-cards-container::-webkit-scrollbar-thumb:hover {
  background-color: var(--gray11);
}

/* Responsive Styles for Screen Width < 560px */
@media (max-width: 560px) {
  .modal-content {
    margin-top:15vh;
    width: 343px;
    height: 480px;
  }

  h2 {
    font-size: 20px;
    line-height: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .offer-cards-container {
    padding: 0px 16px;
    height: 400px;
  }

  .offer-card {
    height: 64px;
    padding: 16px;
  }

  .offer-card-image {
    width: 64px;
    height: 40px;

    margin-right: 10px; /* Optional: Adjust margin if needed */
  }

  .offer-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;

  border-radius: 6px;

}


  .offer-card-details {
    font-size: 12px;
    line-height: 18.48px;
  }

  .offer-card-name {
    font-size: 12px;
    line-height: 18.48px;
  }

  .apply-button {
    width: 80px;
    height: 34px;
    padding: 8px 16px;
    font-size: 12px; /* Optional: Adjust font size for better fit */
    line-height: 18.48px;
  }

  /* Optional: Adjust other elements if necessary */
}
</style>
